export default __webpack_public_path__ + "static/media/DPE_E.ff66c74f.png";